import {
  FoodImageBox,
  FoodInfoBox,
  FoodRight,
  FoodName,
  FoodNutrient,
  SelectButtonWrapper,
  StyledFoodListItem,
  UncheckedIcon,
  CheckedIcon,
  FoodBottomInfo,
  FoodBrand,
  FoodLeft,
} from "./styled"
import { getDisplayCalories, getDisplayPortion } from "utils"
import SmallFoodImage from "components/foodDetails/share/SmallFoodImage"
import { useScannedImageUploader } from "features/meal/hooks/useScannedImageUploader"
import { useFoodBrandMaxWidth } from "utils/hooks"
import { formatUnit } from "utils/formater"
import SmallChevronRight from "components/Icons/SmallChevronRight"
import { AIScanFoodOptionType } from "model/food/types"
import { isEdamaFood } from "model/food/utils/typeGuards/foodTypeGuards"
import { isManuallyAddedFoodsInAIFlow } from "features/food/hooks/scanResultFoods/useScanFlowFoodOptions"
import { getFoodBrand } from "utils/foodDisplay"

const SelectButton = ({ checked }: { checked?: boolean }) => {
  return (
    <SelectButtonWrapper>
      {checked ? (
        <CheckedIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M11.6673 3.5L5.25065 9.91667L2.33398 7"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </CheckedIcon>
      ) : (
        <UncheckedIcon />
      )}
    </SelectButtonWrapper>
  )
}

interface IFoodListItemProps {
  food: AIScanFoodOptionType
  toggleSelectFood?: (food: AIScanFoodOptionType) => void
  style?: React.CSSProperties
  selected?: boolean
  onViewDetails?: (food: AIScanFoodOptionType) => void
}

const FoodOption = (props: IFoodListItemProps) => {
  const { food, toggleSelectFood, style = {}, onViewDetails } = props
  const { name, imageUrl, calorie, unit, portion } = food

  const { displayImageUrl: scanResultFoodImage } = useScannedImageUploader(
    food.id,
  )

  const displayImageUrl = isManuallyAddedFoodsInAIFlow(food)
    ? imageUrl
    : scanResultFoodImage

  const foodBrand = getFoodBrand(food)

  const { brandMaxWidth, foodNutritionRef } = useFoodBrandMaxWidth({
    brand: foodBrand,
    marginRight: 10,
  })

  return (
    <StyledFoodListItem style={style} $isSelected={food.isSelected}>
      <FoodLeft onClick={() => toggleSelectFood?.(food)}>
        <SelectButton checked={food.isSelected} />
      </FoodLeft>

      <FoodRight onClick={() => onViewDetails?.(food)}>
        <FoodImageBox>
          <SmallFoodImage src={displayImageUrl} placeholderBg="transparent" />
        </FoodImageBox>

        <FoodInfoBox>
          <FoodName>{name}</FoodName>
          <FoodBottomInfo>
            <FoodNutrient ref={foodNutritionRef}>
              {getDisplayCalories(calorie)} cal, {getDisplayPortion(portion)}{" "}
              {formatUnit(unit, isEdamaFood(food))}
            </FoodNutrient>

            {foodBrand && (
              <FoodBrand style={{ maxWidth: brandMaxWidth }}>
                <p> {foodBrand}</p>
              </FoodBrand>
            )}
          </FoodBottomInfo>
        </FoodInfoBox>

        <SmallChevronRight />
      </FoodRight>
    </StyledFoodListItem>
  )
}

export default FoodOption
